import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERIES } from "../lib/seriesData";
import Seo from "../components/Seo";

export default function Catalogue() {
  return (
    <section data-testid="catalogue-page" className="bg-[#F9FAFB] min-h-screen">
      <Seo
        title="Catalogue · 25 Hardware Series | KNOVAS Kitchen & Wardrobe Fittings"
        description="Browse the complete KNOVAS catalogue — 25 series of premium modular kitchen and wardrobe hardware including hinges, slides, tandem boxes, baskets, pantry units, magic corners and more."
        path="/catalogue"
      />
      {/* Header */}
      <div className="border-b border-[#E5E7EB] bg-white">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.4em] uppercase text-[#FF6A00] mb-6">Index · 25 Series</p>
            <h1
              className="text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight text-[#2B2B2B] leading-[0.9]"
              style={{ fontFamily: "'Anton', sans-serif", letterSpacing: "-0.01em" }}
            >
              The KNOVAS<br />Catalogue Index
            </h1>
          </div>
          <div className="lg:col-span-5">
            <div className="border-l-2 border-[#FF6A00] pl-6">
              <p className="text-sm sm:text-base text-[#4B5563] leading-relaxed">
                Browse the complete product hierarchy. Every series below opens onto detailed technical specifications,
                product codes and pricing — engineered for builders, fabricators and modular kitchen specialists.
              </p>
            </div>
            <div className="mt-8 grid grid-cols-3 gap-6 text-[#2B2B2B]">
              <div>
                <div className="text-3xl font-black" style={{ fontFamily: "'Anton', sans-serif" }}>25</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#6B7280] mt-1">Series</div>
              </div>
              <div>
                <div className="text-3xl font-black" style={{ fontFamily: "'Anton', sans-serif" }}>1×</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#6B7280] mt-1">Standard</div>
              </div>
              <div>
                <div className="text-3xl font-black" style={{ fontFamily: "'Anton', sans-serif" }}>∞</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#6B7280] mt-1">Combinations</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Series List — editorial dense list */}
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-12 text-[10px] tracking-[0.3em] uppercase text-[#6B7280] border-b border-[#E5E7EB] pb-3 mb-2">
          <div className="col-span-2 md:col-span-1">#</div>
          <div className="col-span-7 md:col-span-6">Series</div>
          <div className="hidden md:block md:col-span-4">Tagline</div>
          <div className="col-span-3 md:col-span-1 text-right">View</div>
        </div>

        <ul data-testid="series-index-list">
          {SERIES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/series/${s.slug}`}
                data-testid={`series-link-${s.number}`}
                className="group grid grid-cols-12 items-center gap-4 py-5 border-b border-[#E5E7EB] hover:bg-white transition-colors"
              >
                <div
                  className="col-span-2 md:col-span-1 text-3xl md:text-4xl font-black text-[#2B2B2B] group-hover:text-[#FF6A00] transition-colors"
                  style={{ fontFamily: "'Anton', sans-serif" }}
                >
                  {s.number}
                </div>
                <div className="col-span-7 md:col-span-6">
                  <div className="text-base md:text-lg font-bold uppercase tracking-wider text-[#2B2B2B]">
                    {s.title}
                  </div>
                </div>
                <div className="hidden md:block md:col-span-4 text-sm text-[#6B7280]">
                  {s.tagline}
                </div>
                <div className="col-span-3 md:col-span-1 flex justify-end">
                  <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#2B2B2B] group-hover:text-[#FF6A00]">
                    Open
                    <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
